import { Box, Paper, useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import Prism from 'prismjs';
// Import both themes - the light theme will automatically apply in light mode
import 'prismjs/themes/prism.css';  // Light theme (default)
import 'prismjs/themes/prism-tomorrow.css'; // Dark theme
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-jsx';
import 'prismjs/components/prism-typescript';
// Apply some custom styling
import './prism-custom.css';

function CodeBlock({ code, language = 'javascript' }) {
  const [formattedCode, setFormattedCode] = useState(code);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  
  useEffect(() => {
  
    const highlighted = Prism.highlight(
      code,
      Prism.languages[language],
      language
    );

    setFormattedCode(highlighted);
  }, [code, language]);

  return (
    <Paper
      component="pre"
      className={isDarkMode ? 'dark-theme' : 'light-theme'}
      elevation={0}
      sx={{
        p: 2,
        mt: 1,
        mb: 2,
        backgroundColor: isDarkMode ? '#1e1e1e' : '#f8f8f8',
        borderRadius: 1,
        overflowX: 'auto',
        fontSize: '0.875rem',
        fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
        '&::-webkit-scrollbar': {
          height: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: isDarkMode ? '#555555' : '#cccccc',
          borderRadius: '4px',
        },
      }}
    >
      <Box
        component="code"
        className={`language-${language}`}
        dangerouslySetInnerHTML={{ __html: formattedCode }}
        sx={{
          whiteSpace: 'pre',
          display: 'block',
        }}
      />
    </Paper>
  );
}

export default CodeBlock; 